import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from "@angular/material";
import { FormGroup, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { MiscService } from 'src/services/misc.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { BehaviorSubject } from 'rxjs';
import { MedicineService } from 'src/services/medicine.services';
import { BatchService } from 'src/services/batch.services';

@Component({
  selector: 'app-link-device-dialog',
  templateUrl: './link-device-dialog.component.html',
  styleUrls: ['./link-device-dialog.component.css']
})
export class LinkDeviceDialogComponent implements OnInit {
  linkTypes: any[];
  selectedLinkType: string;
  selectedPackageLevel: string;
  truckPackageLevel: string;

  assetId: any;
  instanceId: any;
  packageId: any;
  truckPackageId: any;
  
  packageLevels: any[] = [
    {displayName: "Secondary", name: "secondary"},
    {displayName: "Tertiary", name: "tertiary"}
  ];
  packageList: any[];

  trucks: any[] = [];
  gcp: any;
  truckItems: any[] = [
    { name: "Track packaged items", value: "package"},
    { name: "Track Batch/Lot", value: "batch"},
  ];
  truckItemsType: string = "package";
  // productId: any;
  pageSize: number = 5;

  lotForm: FormGroup;
  lots: FormArray = this.fb.array([]);;

  dataSource = new BehaviorSubject<AbstractControl[]>([]);
  displayedColumns: any = ['medicine', 'batch', 'quantity'];
  tableData: TableData[] = [ { medicine: null, batch: null, quantity: null } ];

  medicines: any[];
  batches: any[];

  constructor(
    private dialogRef: MatDialogRef<LinkDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private miscService: MiscService,
    private globalCfgService: GlobalCfgService,
    private medicineService: MedicineService,
    private batchService: BatchService,
  ) {
    this.lotForm = this.fb.group({
      'lots': this.lots
    });
  }

  ngOnInit() {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    this.loadLinkTypes();
    this.loadTrucks();
    if (this.data.readOnly || this.data.editMode) {
      if (this.data.record["linkedWithType"] == "truck") {
        this.selectedLinkType = this.data.record["linkedWithType"];
        this.assetId = this.data.record["assetId"];
        if (this.data.record["isPackage"]) {
          this.truckItemsType = "package";
          this.truckPackageLevel = this.data.record["linkedWithPackageLevel"];
          this.getPackages(this.truckPackageLevel);
          this.truckPackageId = this.data.record["linkedItemId"];
        } else {
          this.truckItemsType = "batch";
          // TODO :- view dialog box for batches
        }
      } else if (this.data.record["linkedWithType"] == "package") {
        this.selectedLinkType = this.data.record["linkedWithType"];
        this.selectedPackageLevel = this.data.record["linkedWithPackageLevel"];
        this.getPackages(this.selectedPackageLevel);
        this.packageId = this.data.record["linkedItemId"];
      } else {
        this.selectedLinkType = this.data.record["linkedWithType"];
        this.instanceId = this.data.record["linkedItemId"];
      }
    }
  }

  loadLinkTypes() {
    this.miscService.getLinkTypes().subscribe(
      (result) => {
        this.linkTypes = result['data'];
      }
    );
  }

  handleLinkType(value) {
    console.log("linkType value: ", value);
    if (value == "truck") {
      // this.loadTrucks();
    }
    if (value == "package") {
      // get packageLevels and truckItems from API
    }
    if (value == "instance") {
      // auto complete for instance
    }
  }

  changeRadioValue(event) {
    if (event.value == "package") {
      // get packageLevels and truckItems from API
    }
    if (event.value == "batch") {
      this.tableData.forEach((d: TableData) => this.addLot(d, false));
      this.updateView();
      this.loadMedicines();
    }
  }

  getPackages(packageLevel) {
    this.miscService.getPackagesList(this.gcp, packageLevel).subscribe(
      (response) => {
        this.packageList = response["result"];
        console.log("response of packageList: ", this.packageList);
      }
    );
  }

  loadMedicines() {
    this.medicineService.getList(this.gcp).subscribe(
      (result: any[]) => {
        this.medicines = result;
      }
    );
  }

  loadBatches(value, row, idx) {
    // var obj = {};

    // if (this.gcp) {
    //   obj['gcp'] = this.gcp;
    // }

    // obj['gtin'] = value;
    // obj['pageSize'] = this.pageSize;

    // this.batchService.get(obj).subscribe(
    //   (response) => {
    //     this.batches = response["result"];
    //   }
    // );
    console.log("value of batch: ", value);
    console.log("row of batch: ", row);
    console.log("index of batch: ", idx);
  }

  addLot(d?: TableData, noUpdate?: boolean) {
    const row = this.fb.group({
      'medicine'   : [d && d.medicine ? d.medicine : null, []],
      'batch'     : [d && d.batch   ? d.batch   : null, []],
      'quantity'     : [d && d.quantity   ? d.quantity   : null, []]
    });
    this.lots.push(row);
    if (!noUpdate) { this.updateView(); }
  }


  updateView() {
    this.dataSource.next(this.lots.controls);
  }

  cancel() {
    this.dialogRef.close();
  }

  save(values) {
    var record = {}

    record["linkedWithType"] = this.selectedLinkType;

    if (this.selectedLinkType == "instance") {
      record["linkedItemId"] = this.instanceId;
      record["isPackage"] = false;
    }

    if (this.selectedLinkType == "package") {
      record["linkedWithPackageLevel"] = this.selectedPackageLevel;
      record["linkedItemId"] = this.packageId;
      record["isPackage"] = true;
    }

    if (this.selectedLinkType == "truck") {
      record["assetId"] = this.assetId;
      if (this.truckItemsType == "package") {
        record["isPackage"] = true;
        record["linkedItemId"] = this.truckPackageId;
        record["linkedWithPackageLevel"] = this.truckPackageLevel;
      }
      if (this.truckItemsType == "batch") {
        // record["linkedItemId"] = this.truckPackageId;
      }
    }

    this.dialogRef.close(record);
  }

  loadTrucks() {
    this.miscService.getAssets(this.gcp, 'TRUCK').subscribe(
      (result) => {
        this.trucks = result['data'];
      }
    );
  }

  // set selected packageId value from autocomplete 
  setSelectedPackageId(value) {
    this.packageId = value;
  }
}

export interface DialogData {
  title: string;
  record: any;
  readOnly: boolean;
  editMode: boolean;
}

export interface TableData {
  medicine: any;
  batch: any;
  quantity: any;
}